import React, { useState } from "react";

import { Error } from "@mui/icons-material";
import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";

import { OrgSsoSettings } from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/idp_pb";

interface DeleteSSOConnectionConfirmationProps {
  orgName: string;
  isConnectionOwner: boolean;
  otherConnectionOrgs: OrgSsoSettings[];
  handleConfirmSSOConnectionDeletionCheck: (isEqual: boolean) => void;
}

const DeleteSSOConnectionConfirmation = ({
  orgName,
  handleConfirmSSOConnectionDeletionCheck,
  isConnectionOwner,
  otherConnectionOrgs,
}: DeleteSSOConnectionConfirmationProps) => {
  const theme = useTheme();

  const [inputOrgName, setInputOrgName] = useState("");

  return (
    <>
      <Grid container direction="row" spacing={1} style={{ minWidth: 350 }}>
        <Grid item xs={12} container direction="column">
          <Box
            bgcolor={theme.palette.warning.main}
            borderRadius="5px"
            border={1}
            borderColor={theme.palette.secondary.main}
            marginBottom={3}
          >
            <Grid container alignItems="center">
              <Grid item xs={2} container justifyContent="center">
                <Error fontSize="large" />
              </Grid>
              <Grid item xs={10} style={{ paddingRight: "20px" }}>
                <p>
                  You are about to <b>permanently delete</b> this sso
                  connection.
                </p>
                <p>
                  Users may <b>not</b> be able to log into SafetyCulture as a
                  result of this action. You must confirm with the SafetyCulture
                  account admin before proceeding.
                </p>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {otherConnectionOrgs.length > 0 && (
          <Grid item xs={12} style={{ paddingBottom: "20px" }}>
            <Box>
              <b>
                {isConnectionOwner ? (
                  <span data-testid="deleted-other-orgs-impacted">
                    {otherConnectionOrgs.length} other organisations will be
                    impacted by deleting this SSO connection as this
                    organisation owns the connection.
                  </span>
                ) : (
                  <span data-testid="deleted-auth0-connection-not-deleted">
                    The underlying Auth0 connection will NOT be deleted as{" "}
                    {otherConnectionOrgs.length} other orgs utilise this
                    connection. Consider deleting it from the owner{" "}
                  </span>
                )}
              </b>
            </Box>
          </Grid>
        )}
        <Grid item xs={12}>
          <Box>
            <Typography variant="body1">
              Type the name of the organisation to confirm the sso connection
              deletion
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="orgName-input"
            label="Organisation Name"
            value={inputOrgName}
            onChange={(e) => {
              setInputOrgName(e.target.value);
              handleConfirmSSOConnectionDeletionCheck(
                e.target.value !== orgName,
              );
            }}
            variant="outlined"
            size="small"
            fullWidth
            inputProps={{
              "data-anchor": "do-name-input",
              "data-testid": "do-name-input",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DeleteSSOConnectionConfirmation;
